// Browser alias target for Node-only packages whose import sites are never reached client-side (see next.config.ts).
export {};
